import { useEffect } from "react";

export type SelectOption = { value: string };

/** Returns the sole option value when options.length === 1 and value differs; otherwise undefined. */
export function getAutoSelectedSingleOptionValue(
  options: SelectOption[],
  value: string | undefined,
): string | undefined {
  if (options.length !== 1) return undefined;

  const sole = options[0].value;
  return value !== sole ? sole : undefined;
}

export function useAutoSelectSingleOption(
  options: SelectOption[],
  value: string | undefined,
  onSelect: (value: string) => void,
) {
  useEffect(() => {
    const selected = getAutoSelectedSingleOptionValue(options, value);
    if (selected !== undefined) onSelect(selected);
  }, [options, value, onSelect]);
}
